exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1ITMqGoVbdzRiWz_ZaROip{width:32px;height:32px;line-height:32px}html[dir] ._1ITMqGoVbdzRiWz_ZaROip{border-radius:50%;text-align:center}._26GKG3JyHseGNrPDwhdFNu{color:\"[theme:white, default:#ffffff]\"}", ""]);
// Exports
exports.locals = {
	"roomIconContainer": "_1ITMqGoVbdzRiWz_ZaROip",
	"roomIcon": "_26GKG3JyHseGNrPDwhdFNu"
};